import React from 'react';
import { create } from 'jss';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, jssPreset, ThemeProvider } from '~/lib/bn-material-ui';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import LevelHistory from '../../bins/level-history/level-history';

export function levelHistoryParcel(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider jss={jss} generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 jss={jss} generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <LevelHistory href={props.href} />
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
